// docs/56 EP5 — the party's last hero has fallen on the board. Once the slow fall has landed, a
// DEFEAT stamp goes up across the top of the board with a red vignette; the fight's end (the Spoils
// screen) waits on it until the player continues (RouteDriver reads `defeat.continued`).
import { useEffect, useState } from 'react';
import { Button, Stamp, afterMotion } from '../components';
import { useCinematic } from '../../core/stores/cinematic';
import { useEncounter } from '../../core/encounter/session';
import { FINAL_FALL_MS } from '../../core/playback/catalogue';

export function DefeatCard() {
  const defeat = useCinematic((s) => s.defeat);
  const encounterId = useEncounter((s) => s.encounterId);
  const busy = useEncounter((s) => s.busy);
  const mine = !!defeat && defeat.encounterId === encounterId && !defeat.continued;
  // the stamp lands as the body does; the button once the pulse has finished playing
  const [shown, setShown] = useState(false);
  useEffect(() => { if (!mine) { setShown(false); return; } return afterMotion(FINAL_FALL_MS * 0.7, () => setShown(true)); }, [mine]);
  if (!mine || !shown) return null;
  return (
    <div className="fk-defeat" role="alertdialog" aria-label="Defeat" data-testid="defeat-card">
      <div className="fk-defeat__vignette" aria-hidden="true" />
      <div className="fk-defeat__card">
        <Stamp tone="defeat" sub={`${defeat.hero} has fallen. The party is beaten.`}>Defeat</Stamp>
        <Button primary size="lg" className="fk-hit fk-defeat__go" disabled={busy} onClick={() => useCinematic.getState().continueDefeat()} data-testid="defeat-continue">Continue</Button>
      </div>
    </div>
  );
}
